import {
  Description,
  Schedule,
  CalendarToday,
  DevicesOtherOutlined,
  InfoOutlined,
} from '@material-ui/icons';
import styled from 'styled-components';
import { HorizontalScrollBoxWrapper } from '../../../../common/components/HorizontalScrollBox/HorizontalScrollStyles';
import { StyledLink } from '../../../../common/components/Link.styles';
import { Breakpoint, FontSize, FontWeight } from '../../../../common/styles/constants';
import { Badge } from '../ProfileCards/search-card/Badges/Badge/Badge';
import { AdventureTime } from '../ResultList.styles';

export const DescriptionIconStyled = styled(Description)``;

export const ScheduleIconStyled = styled(Schedule)``;

export const CalendarTodayIconStyled = styled(CalendarToday)``;

export const DevicesOtherOutlinedStyled = styled(DevicesOtherOutlined)``;

export const InfoOutlinedStyled = styled(InfoOutlined)`
  font-size: ${FontSize.HEADING_4} !important;
  margin-right: 4px;
`;

export const TelehealthActionsInfoCTALabel = styled(StyledLink)`
  font-size: ${FontSize.EXTRA_SMALL};
`;

export const TelehealthActionsInfoCTA = styled(Badge)`
  align-items: center;
  display: flex;
  margin: 0;
  padding-left: 0;

  ${Breakpoint.SMALL} {
    padding-left: 6px;
  }
`;

export const TelehealthActionsInfoCTAContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  font-weight: ${FontWeight.REGULAR};
  text-transform: none;
`;

export const TelehealthActionsCardContainer = styled.div`
  position: relative;

  ${Breakpoint.SMALL} {
    ${HorizontalScrollBoxWrapper} {
      flex-wrap: wrap;
      overflow: visible;
    }
  }
`;

export const TelehealthActionsAdventureTime = styled(AdventureTime)`
  align-items: flex-start;
  flex-direction: column-reverse;
  margin: 8px 0;

  ${Breakpoint.SMALL} {
    align-items: center;
    flex-direction: row;
  }
`;
